import axios from "axios";
import { url } from "../baseUrl";
export const AuthStore = {
  state: {
    token: localStorage.getItem("auth_token") || null,
    phone_number: null,

    signup_code: null,
    signup_verified: false,
    signup_token: null,

    login_code: null,
    login_verified: localStorage.getItem("login_verified") || false,

    reset_code: null,
    reset_verified: false, // 0: Invisible, 1: Register, 2: Login
    snack_show: 0,

    invited: {
      uuid: ''
    }
  },
  mutations: {
    register(state, data) {
      state.signup_code = data.signup_code;
      state.phone_number = data.phone_number;
    },
    register_verify(state, data) {
      state.signup_verified = true;
      state.signup_token = data.token;
      state.snack_show = 1;
    },
    login(state, data) {
      state.token = data.token;
      state.phone_number = data.phone_number;
      state.login_code = data.login_code;
    },
    login_verify(state) {
      state.login_verified = true;
      localStorage.setItem("login_verified", true);
    },
    logout(state) {
      state.token = null;
      state.phone_number = null;

      state.signup_code = null;
      state.signup_verified = false;

      state.login_code = null;
      state.login_verified = false;

      localStorage.removeItem("auth_token");
      localStorage.removeItem("login_verified");
    },

    reset_request(state, data) {
      state.phone_number = data.phone_number;
      state.reset_code = data.reset_code;
    },

    reset_verify(state) {
      state.reset_verified = true;
    },

    reset_new_password(state) {
      state.token = null;
      state.login_verified = false;
      state.snack_show = 2;
    },

    invite_detail(state, data) {
      state.invited = data
    }
  },
  actions: {
    invite_detail(context, data) {
      return new Promise((resolve, reject) => {
        axios.post(url.baseUrl + "/idm/invite/detail/", data)
          .then(response => {
            context.commit("invite_detail", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    invite_accept(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/idm/invite/accept/?uuid=" + data.uuid,
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        }).then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });          
      });
    },
    register(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(url.baseUrl + "/accounts/signup/", {
            username: data.username,
            email: data.email,
            password: data.password,
            phone_number: data.phone_number
          })
          .then(response => {
            context.commit("register", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    register_verify(context, data) {

      return new Promise((resolve, reject) => {
        axios
          .get(url.baseUrl + "/accounts/signup/verify/?code=" + data.code + "&uuid=" + data.uuid, {})
          .then(response => {
            const token = response.data.token;
            localStorage.setItem("auth_token", token);
            context.commit("register_verify", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    login(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(url.baseUrl + "/accounts/login/", {
            username: data.username,
            password: data.password
          })
          .then(response => {
            const token = response.data.token;
            localStorage.setItem("auth_token", token);
            context.commit("login", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    login_verify(context, data) {
      return new Promise((resolve, reject) => {
        if (context.state.login_code == data.code) {
          context.commit("login_verify");
          resolve();
        } else {
          reject("code is incorrect");
        }
      });
    },

    logout(context) {
      if (context.state.login_verified) {
        context.commit("logout");
      }
    },

    reset_request(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(url.baseUrl + "/accounts/password/reset/", {
            username: data.username,
            phone_number: data.phone_number
          })
          .then(response => {
            context.commit("reset_request", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    reset_verify(context) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            url.baseUrl +
              "/accounts/password/reset/verify/?code=" +
              context.state.reset_code,
            {}
          )
          .then(response => {
            context.commit("reset_verify");
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    reset_new_password(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(url.baseUrl + "/accounts/password/reet/verified/", {
            code: context.state.reset_code,
            password: data.password
          })
          .then(response => {
            context.commit("reset_new_password");
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
